import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import {
  setCounty,
  setCountryDialingList,
} from "./../Redux/Slices/SettingSlice";
import { CountryResponseModel } from "./../Helpers/Interfaces/SettingType";
import Config from "../Config";

export const CountryService = createApi({
  reducerPath: "CountryService",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["Country"],
  keepUnusedDataFor: 600,
  endpoints: (builder) => ({
    getAllCountry: builder.query({
      query: ({ ...patch }) => ({
        url: `${ApiPath.getAllCountry}`,
        method: "POST",
        body: patch,
      }),
      providesTags: ["Country"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data }: any = await queryFulfilled; // Wait for the query to resolve

          // Create a new sorted array to avoid mutating the original response
          const sortedCountryList = [...data.data].sort(
            (
              a: { name: { common: string } },
              b: { name: { common: string } },
            ) => a.name.common.localeCompare(b.name.common),
          );
          dispatch(
            setCounty({
              countryList: sortedCountryList,
            }),
          );
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      },
    }),

    getCountryDialingList: builder.query<CountryResponseModel, void>({
      query: () => ({
        url: `${ApiPath.countryDialingInfoApi}`,
        method: "POST",
        body: { filters: [{ key: "phoneRefil", value: true }] },
      }),
      providesTags: ["Country"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data }: any = await queryFulfilled;
          const formattedOptions = data.data
            .map((country: any) => {
              const dialingCode = country.dailCode
                ? `${country.dailCode}`
                : country.idd
                  ? `${country.idd}`
                  : "N/A";
              // Extract the currency code (e.g., ZMW) and its info
              const currencies: any = {};
              if (
                country?.currencies &&
                Object.keys(country.currencies).length > 0
              ) {
                const [iso, info]: any = Object.entries(country.currencies)[0];
                currencies.iso = iso;
                currencies.symbol = info?.symbol;
              }
              return {
                label: `${country.CountryName}`,
                value: country.CountryIso,
                extraData: {
                  dialingCode,
                  currencies,
                  phoneRefil: country.phoneRefil,
                  mobileLength: {
                    min: country.phoneNumberLength.Minimum,
                    max: country.phoneNumberLength.Maximum,
                  },
                },
              };
            })
            .sort((a: { label: string }, b: { label: string }) =>
              a.label.localeCompare(b.label),
            );
          dispatch(
            setCountryDialingList({ countryDialingList: formattedOptions }),
          );
        } catch (error) {
          console.error("Error fetching country dialing data:", error);
        }
      },
    }),
  }),
});

export const { useLazyGetAllCountryQuery, useLazyGetCountryDialingListQuery } =
  CountryService;
